export default function Marquee({ items }) {
  const row = (ariaHidden) => (
    <div className="flex shrink-0 items-center" aria-hidden={ariaHidden || undefined}>
      {items.map((item, i) => (
        <span key={i} className="flex items-center">
          <span className="font-display font-medium text-2xl sm:text-3xl tracking-wide text-bone/80 px-8 whitespace-nowrap">
            {item}
          </span>
          <span className="w-1.5 h-1.5 rounded-full bg-teal/70 shrink-0" />
        </span>
      ))}
    </div>
  );
  return (
    <div className="marquee relative border-y border-line py-6 overflow-hidden" data-testid="editorial-marquee">
      <div className="marquee-track">
        {row(false)}
        {row(true)}
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-ink to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-ink to-transparent" />
    </div>
  );
}
